<template>
  <v-container
    v-if="!$apollo.loading && schema"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
        md6
      >
        <v-card>
          <v-flex xs12>
            <div
              v-for="(field, i) in schema"
              :key="i"
              class="mt-3"
            >
              <component
                :is="field.values && field.values === ':products:' ? loadField('products') : loadField(field.field)"
                :ref="field.key"
                :opts="field"
                :config="form.config ? form.config[field.key] : null"
              />
            </div>
          </v-flex>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              :disabled="loading"
              @click="$emit('closeEditMode', false)"
            >
              {{ $t("globals.cancelButton") }}
            </v-btn>
            <v-btn
              :disabled="loading"
              :loading="loading"
              class="primary"
              @click="save()"
            >
              {{ $t("globals.saveButton") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MdText from "@/components/ui/Text.vue";
import MdSelect from "@/components/ui/Select.vue";
import MdCheckbox from "@/components/ui/Checkbox.vue";
import MdProducts from "@/components/ui/Products.vue";

import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";

import UPDATE_CONFIG_MUTATION from "@/graphql/mutations/modules/UpdateConfig.gql";

export default {
  name: "ModuleConfig",
  components: {
    MdText,
    MdSelect,
    MdCheckbox,
    MdProducts
  },
  mixins: [validationMixin],
  props: {
    module: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      schema: null,
      form: {
        config: null,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    loadField() {
      return (value) => "md-" + value;
    },
  },
  watch: {
    getWhiteLabel() {
      this.$emit("closeEditMode", false);
    },
  },
  mounted() {
    this.schema = JSON.parse(this.module.custom_config_schema);
    this.form.config = JSON.parse(this.module.custom_config);
  },
  methods: {
    save() {
      let validated = true;
      let config = {};

      this.schema.forEach((item) => {
        let field = this.$refs[item.key][0];

        if (item.field == "checkbox" && field[item.key] == null)
          field[item.key] = false;

        config[item.key] = field[item.key];
        if (field.$v != undefined) {
          field.$v.$touch();
          if (field.$v.$invalid) {
            validated = false;
            return;
          }
        }
      });
      config = JSON.stringify(config);

      if (validated) {
        this.loading = true;
        this.$apollo
          .mutate({
            mutation: UPDATE_CONFIG_MUTATION,
            variables: {
              whitelabel_uuid: this.getWhiteLabel.uuid,
              module: this.module.module,
              custom_config: config,
            },
          })
          .then((data) => {
            this.loading = false;
            this.$emit("closeEditMode", true);
          })
          .catch((error) => {
            this.loading = false;
            if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
              this.$store.commit("app/setShowPermission");
              return;
            }
            this.errorHandler(error);
          });
      }
    },
  },
  validations() {
    return {};
  },
};
</script>
<style lang="scss" scoped></style>
